import React, { Component } from "react";
import ShortValueField from "../fields/shortValueField";
import {BrowserView, MobileView} from 'react-device-detect';
// import "../../styles/landregistry.css";
import store from './../../../store';
import { selectConfig } from "./../../redux/slices/configSlice";
import { ConfigContext } from "./../../context/ConfigContext";
import { connect, useSelector } from 'react-redux';
import {
  setPrevStage, 
  setNextStage,
  setStage,
  setShow,
  setDataField
} from './../../redux/slices/landSearchSlice';
import {setFeeValue, setPaymentField} from './../../redux/slices/paymentSlice';


class SearchLandResultsForm extends Component {
  static contextType = ConfigContext; 
  config = selectConfig(store.getState());

  /* before redux
  state = {
    searchResult: this.props.searchResult,
    additionSearchResults: this.props.additionSearchResults,
    updateShowCase: this.props.updateShowCase,
    nextStage: this.props.nextStage,
    errorStage: this.props.errorStage,
    deliveryType: "Digital print",
    paymentMethod: "Online",
    propertyName: "",
    backToPrevStage: this.props.backToPrevStage,
    prevStage: this.props.prevStage,
    landid: null,
    land_no: this.props.land_no,
    block_no: this.props.block_no
  };
  
  constructor(props) {
    super(props);
    this.confirmData = this.confirmData.bind(this);
  }
  */

  componentDidMount() {
    this.props.setShow("searchResults");
    this.props.setPrevStage("searchForm");
    this.props.setNextStage("paymentDetails");
  }

  componentDidUpdate(prevProps) {
    const {
      searchResult,
      additionSearchResults,
      setDataField // from props
    } = this.props;

    // Check if searchResult changed
    if (searchResult && searchResult !== prevProps.searchResult) {
      try {
        const searchJSON = JSON.parse(searchResult);
        const item = searchJSON[0];

        if (item?.LAND_NO !== undefined) {
          setDataField({ filed: "Land_No", value: item.LAND_NO });
        }

        if (item?.LAND_ID !== undefined) {
          this.props.setPaymentField({field:"LandId", value:item.LAND_ID});
        }
      } catch (error) {
        console.error("Invalid JSON in searchResult:", error);
      }
    }

    // Check if additionSearchResults changed
    if (additionSearchResults && additionSearchResults !== prevProps.additionSearchResults) {
      try {
        const additionJSON = JSON.parse(additionSearchResults);

        const table1Item = additionJSON?.Table1?.[0];
        const table2Item = additionJSON?.Table2?.[0];

        if (table1Item?.LAND_NO !== undefined) {
          setDataField({ filed: "Land_No", value: table1Item.LAND_NO });
        }

        if (table1Item?.LAND_ID !== undefined) {
          this.props.setPaymentField({field:"LandId", value:table1Item.LAND_ID});
        }

        if (table2Item?.VALUE !== undefined) {
          const feeValue = table2Item.VALUE
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          this.props.setFeeValue(feeValue); 
        }
      } catch (error) {
        console.error("Invalid JSON in additionSearchResults:", error);
      }
    }
  }

  confirmData = () => {
    /*before redux
    const { updateShowCase, nextStage } = this.state;
    updateShowCase(nextStage);
    */
    const {nextStage} = this.props;

    this.props.setShow(nextStage);
  };

  backStage = () => {
    /* before redux
    const { backToPrevStage, prevStage, land_no, block_no } = this.state;
    backToPrevStage(prevStage, land_no, block_no);
    */

    const { prevStage, data} = this.props;
    this.props.backToPrevStage(prevStage, data.Land_No, data.Block_No);
  };

  render() {
    const { deliveryType, data } = this.props;

    /*
    let landid = "";
    let feeValue = "";
    let searchJSON = "";
    let additionSearchJSON = "";
    if (searchResult !== undefined) {
      searchJSON = JSON.parse(searchResult);
      if (searchJSON[0] !== undefined && searchJSON[0].LAND_NO !== undefined)
      // before redux land_no = searchJSON[0].LAND_NO;
        this.props.setDataField({filed:"Land_No", value:searchJSON[0].LAND_NO});
      if (searchJSON[0] !== undefined && searchJSON[0].LAND_ID !== undefined)
        landid = searchJSON[0].LAND_ID;
    }
    if (additionSearchResults) {
      additionSearchJSON = JSON.parse(additionSearchResults);

      if (
        additionSearchJSON !== undefined &&
        additionSearchJSON.Table1 !== undefined &&
        additionSearchJSON.Table1[0] !== undefined
      )
      {
        if (additionSearchJSON.Table1[0].LAND_NO !== undefined)
        //before redux land_no = additionSearchJSON.Table1[0].LAND_NO;
        this.props.setDataField({filed:"Land_No", value:additionSearchJSON.Table1[0].LAND_NO});

        if (additionSearchJSON.Table1[0].LAND_ID !== undefined)
          landid = additionSearchJSON.Table1[0].LAND_ID;
      }
      if (
        additionSearchJSON !== undefined &&
        additionSearchJSON.Table2 !== undefined &&
        additionSearchJSON.Table2[0] !== undefined &&
        additionSearchJSON.Table2[0].VALUE !== undefined
      )
        feeValue = additionSearchJSON.Table2[0].VALUE.toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }*/
/*
    if (propertyName.length > 11) {
      propertyNameShort = propertyName.substring(0, 9) + " ...";
    }
*/
    return (
      <React.Fragment>
        <div id="SearchLandResultsTitle">
          Property was found. Please confirm the payment amount and method and click “Next” to proceed.
        </div>
        <MobileView>
          <div className="SearchLandResults">
            {/* <div className="ResultRow">
              <div className="ColumnTitle1">Property No.</div>
              <div className="SearchResultItem">
              {propertyName.length > 11 ? (
                <ShortValueField
                  shortValue={propertyNameShort}
                  fullValue={propertyName}
                />
              ) : (
                <div>{propertyName}</div>
              )}
              </div>
            </div> */}
            <div className="ResultRow">
              <div className="ColumnTitle1">Delivery</div>
              <div className="SearchResultItem1">{deliveryType}</div>
            </div>
            <div className="ResultRow">
              <div className="ColumnTitle1">Payment</div>
              <div className="SearchResultItem1">{data.paymentmethod}</div>
            </div>
            <div className="ResultRow">
              <div className="ColumnTitle1">Cost (₦)</div>
              <div className="SearchResultItem1">{data.feeValue.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
            </div>
          </div>
        </MobileView>
        <BrowserView>
          <div className="SearchLandResults">
            <div id="SearchResultTitles">
              {/* <div className="ColumnTitle">Property No.</div> */}
              <div className="ColumnTitle1">Delivery</div>
              <div className="ColumnTitle1">Payment</div>
              <div className="ColumnTitle1">Cost (₦)</div>
            </div>
            <div id="SearchResultData">
              {/* <div className="SearchResultItem">
                {propertyName.length > 11 ? (
                  <ShortValueField
                    shortValue={propertyNameShort}
                    fullValue={propertyName}
                  />
                ) : (
                  <div>{propertyName}</div>
                )}
              </div> */}
              <div className="SearchResultItem1">{deliveryType}</div>
              <div className="SearchResultItem1">{data.paymentmethod}</div>
              <div className="SearchResultItem1">{data.feeValue.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
            </div>
            {/* <div> */}

            {/* </div> */}
          </div>
        </BrowserView>
        
        <MobileView>
          <div className="confirmButtonsDiv">
            <button
              className="btnConfirm"
              type="submit"
              onClick={this.confirmData}
            >
              Next
            </button>
            <button className="btnCancel" onClick={this.backStage}>
              Back
            </button>
          </div>
        </MobileView>
        <BrowserView>
          <div className="confirmButtonsDiv">
              <button className="btnCancel" onClick={this.backStage}>
                Back
              </button>
              <button
                className="btnConfirm"
                type="submit"
                autoFocus
                onClick={this.confirmData}
              >
                Next
              </button>
          </div>
        </BrowserView>
        
      </React.Fragment>
    );
  }
}

 // Map Redux state to props
const mapStateToProps = (state) => {
  const landSearch = state.landSearch;
  const payment = state.payment;
  const data = payment.data || {}; 

  return {
    data,
    searchResult: landSearch.searchResult,
    prevStage: landSearch.prevStage,
    additionSearchResults: landSearch.additionSearchResults,
    deliveryType: payment.deliveryType,
    paymentmethod: data.paymentmethod
  }
};

// Dispatch → props
const mapDispatchToProps = {
  setShow,
  setPrevStage, 
  setNextStage,
  setStage,
  setDataField,
  setFeeValue,
  setPaymentField
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchLandResultsForm);
//export default SearchLandResultsForm;
